"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var generateGuid_1 = require("../methods/generateGuid");
var today_1 = require("../methods/today");
var now_1 = require("../methods/now");
/**
 * Domyślna wartośc na podstawie pól default ze schematu
 * @param schema schemat
 * @param force czy wymusić domyślne wartości dla kazdego pola:
 *  * liczba: `0`
 *  * boolean: `false`
 *  * string: `""`
 *
 */
function defaultValue(schema, force, defaultNumber) {
    if (force === void 0) { force = false; }
    if (defaultNumber === void 0) { defaultNumber = null; }
    var result = null;
    if (schema.type === 'object') {
        if (schema.default !== undefined) {
            if (schema.default === null) {
                return null;
            }
            else {
                return Object.assign({}, schema.default);
            }
        }
        result = {};
        var isEmpty = true;
        if (schema.properties) {
            for (var key in schema.properties) {
                if (schema.properties.hasOwnProperty(key)) {
                    var element = schema.properties[key];
                    var value = defaultValue(element, force, defaultNumber);
                    if (value !== undefined) {
                        result[key] = value;
                        isEmpty = false;
                    }
                }
            }
        }
        if (!isEmpty || schema.$parent === undefined || force) {
            return result;
        }
    }
    else if (schema.type === 'array') {
        var minLength = 0;
        // let minLength = schema.minItems
        if (schema.default !== undefined) {
            if (typeof schema.default === 'number') {
                minLength = schema.default;
            }
            else {
                return Array.from(schema.default);
            }
        }
        if (schema.length !== undefined && typeof schema.length === 'number') {
            minLength = schema.length;
        }
        result = [];
        var isEmpty = true;
        if (schema.items) {
            if (minLength) {
                for (var i = 0; i < minLength; i++) {
                    var value = defaultValue(schema.items, force, defaultNumber);
                    result.push(value);
                    isEmpty = false;
                }
            }
            else {
                /*
                                                const value = defaultValue(schema.items, force);
                                                if (value !== undefined) {
                                                    result.push(value);
                                                    isEmpty = false;
                                                }
                                                */
            }
        }
        // if (!isEmpty) return result;
        if (!isEmpty || schema.$parent === undefined || force) {
            return result;
        }
    }
    if (schema.default !== undefined) {
        switch (schema.type) {
            case 'string':
                switch (schema.format) {
                    case 'date':
                        switch (schema.default) {
                            case 'today':
                            case 'now':
                                return (0, today_1.default)();
                        }
                    case 'date-time':
                        switch (schema.default) {
                            case 'today':
                                return (0, today_1.default)() + ' 00:00:00';
                            case 'now':
                                return (0, now_1.default)();
                        }
                    case 'guid':
                        switch (schema.default) {
                            case 'generate':
                            case 'new':
                                return (0, generateGuid_1.generateGuid)();
                        }
                }
        }
        return schema.default;
    }
    if (force) {
        switch (schema.type) {
            case 'number':
            case 'money':
            case 'integer':
                return defaultNumber;
            case 'boolean':
                return false;
            case 'string':
                switch (schema.format) {
                    case 'guid':
                        return (0, generateGuid_1.generateGuid)();
                    default:
                        return '';
                }
        }
    }
    // return result;
}
exports.default = defaultValue;
//# sourceMappingURL=defaultValue.js.map